import { useQuery } from "@tanstack/react-query";

import { getFeature } from "generated/api/feature";
import { GetAllFeaturesState200 } from "generated/schemas";

import { featureFlagKeys } from "hooks/api/query-keys";

const featureApi = getFeature();

export type FeatureFlags = GetAllFeaturesState200;

export const useFeatureFlagsQuery = () =>
  useQuery({
    queryKey: featureFlagKeys.list(),
    queryFn: () => featureApi.getAllFeaturesState(),
    staleTime: Infinity,
  });
